import Vue from 'vue'

const luPriority = {
  state: {
    luPriorities: [],
    selectedLuPriority: {},
    saving: false,
    searchCount: 0,
  },

  getters: {
    luPriorities(state) {
      return state.luPriorities
    },
    selectedLuPriority(state) {
      return state.selectedLuPriority
    },
    loading(state) {
      return state.searchCount > 0
    },
  },

  mutations: {
    luPriorities(state, payload) {
      state.luPriorities = payload
    },
    selectedLuPriority(state, payload) {
      state.selectedLuPriority = JSON.parse(JSON.stringify(payload))
    },
    saving(state, payload) {
      state.saving = payload
    },
    searchCount(state, payload) {
      state.searchCount = payload
    },
    increaseSearchCount(state, payload) {
      state.searchCount = state.searchCount + 1
    },
    decreaseSearchCount(state, payload) {
      state.searchCount = state.searchCount - 1
    },
  },

  actions: {
    setSelectedLuPriority(context, payload) {
      context.commit('selectedLuPriority', payload)
    },
    loadLuPriorities(context, payload) {
      return new Promise((resolve, reject) => {
        const url = 'LuPriority'
        context.commit('increaseSearchCount')
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('luPriorities', res.data)
            context.commit('decreaseSearchCount')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('decreaseSearchCount')
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    refreshSelectedLuPriority(context, payload) {
      if (
        context.state.selectedLuPriority &&
        context.state.selectedLuPriority.ID
      ) {
        context.dispatch(
          'loadSelectedLuPriority',
          context.state.selectedLuPriority.ID
        )
      }
    },
    loadSelectedLuPriority(context, payload) {
      if (
        context.state.selectedLuPriority &&
        context.state.selectedLuPriority.ID != payload
      ) {
        context.commit('selectedLuPriority', {})
      }
      return new Promise((resolve, reject) => {
        const url = 'LuPriority/' + payload
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('selectedLuPriority', res.data)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    clearLookupCacheAndReloadLuPriorities(context, payload) {
      caches.delete('apilookup-cache').finally(() => {
        context.dispatch('loadLuPriorities')
      })
    },
    updateLuPriority(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `LuPriority/${payload.ID}`
        context.commit('saving', true)
        Vue.prototype.$axios.put(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              { color: 'success', message: 'priority updated' },
              { root: true }
            )
            //if you will always need to reload the list after an update
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadLuPriorities')
            context.commit('saving', false)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('saving', false)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    createLuPriority(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `LuPriority`
        context.commit('saving', true)
        Vue.prototype.$axios.post(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              { color: 'success', message: 'priority created' },
              { root: true }
            )
            //if you will always need to reload the list after an item is created
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadLuPriorities')
            context.commit('saving', false)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('saving', false)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
    saveLuPriority(context, payload) {
      return new Promise((resolve, reject) => {
        if (payload.ID > 0) {
          context.dispatch('updateLuPriority', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        } else {
          context.dispatch('createLuPriority', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        }
      })
    },
    deleteLuPriority(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `LuPriority/${payload.ID}`
        Vue.prototype.$axios.delete(url).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              { color: 'success', message: 'priority deleted' },
              { root: true }
            )
            //if you will always need to reload the list after a delete
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadLuPriorities')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
  },
}

export default luPriority
